"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var UsersTable_vue_1 = __importDefault(require("./TheUsers/UsersTable.vue"));
var ViewWindow_vue_1 = __importDefault(require("./ViewWindow.vue"));
var TopMenu_vue_1 = __importDefault(require("./TheUsers/TopMenu.vue"));
var VPagination_vue_1 = __importDefault(require("./scraps/VPagination.vue"));
var VAlert_vue_1 = __importDefault(require("./scraps/VAlert.vue"));
var UsersMixin_1 = __importDefault(require("../mixins/request/UsersMixin"));
var PermissionsMixin_1 = __importDefault(require("../mixins/request/PermissionsMixin"));
var vue_class_component_1 = __importStar(require("vue-class-component"));
var RolesMixin_1 = __importDefault(require("../mixins/request/RolesMixin"));
var DistrictsMixin_1 = __importDefault(require("../mixins/request/DistrictsMixin"));
var UnitsMixin_1 = __importDefault(require("../mixins/request/UnitsMixin"));
var request_1 = __importDefault(require("../request"));
var TheUsers = /** @class */ (function (_super) {
    __extends(TheUsers, _super);
    function TheUsers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "the-users";
        return _this;
    }
    TheUsers.prototype.created = function () {
        this.requestRoles();
        this.requestUsers();
        this.requestDistricts();
        this.requestUnits();
    };
    TheUsers.prototype.requestDistricts = function () {
        return request_1.default.district.all("", -1, this.updateDistricts);
    };
    TheUsers.prototype.requestUnits = function () {
        return request_1.default.unit.all(0, "", -1, this.updateUnits);
    };
    TheUsers = __decorate([
        vue_class_component_1.default({ components: {
                UsersTable: UsersTable_vue_1.default,
                ViewWindow: ViewWindow_vue_1.default,
                TopMenu: TopMenu_vue_1.default,
                VPagination: VPagination_vue_1.default,
                VAlert: VAlert_vue_1.default
            } })
    ], TheUsers);
    return TheUsers;
}(vue_class_component_1.mixins(RolesMixin_1.default, DistrictsMixin_1.default, UnitsMixin_1.default, UsersMixin_1.default, PermissionsMixin_1.default)));
exports.default = TheUsers;
